/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */
let baseUrls = 'https://service.beeshow.tv/v2';
let routerMode = 'hash';
let imgBaseUrl = '';
let isLocal = true;         //is local debug mode ,traditional 签名要用到
let opSpace = 'showspace';
let opTerminal = 'H';
let opVersion = '8.1.3';
let opDomain = 'rdtest';
let websocketProtocol = location.protocol=='https:' ?'wss://':'ws://';
let systemVar = {
  animationFg:true            //礼物特效开关
}
let isShowLoginMobile = false;
let testEnvironment = false;
let vid = 20001;
let weixinAppKey = 'wxc3bdfa83d667bc2c';
let payChannelId = null;
let isCounting = true;
let logUrl = 'https://service.beeshow.tv';
let websocketServiceURL = ['wss://sx1.beeshow.tv:7443', 'wss://sx2.beeshow.tv:7443'];
let projectType = {
  PROJECT_HONG_REN : 0x01,
  PROJECT_MI_FENG : 0x02
};
let projectVar = {
  moneyName:'蜜钻',
  wx:'蜜疯直播',
  customerServiceQQ:'800108133',
  recruitQQ:'800108133',
  technologyServiceQQ:'2852512885',
  webSiteName:'蜜疯',
  url:'beeshow.tv',
  channelId:'40301100',
  anchorSwfUrl:'swf/anchorSwf/mfanchorplayer.swf',
  indexSwfUrl:'swf/mfindexplayer/mfindexplayer.swf',
  roomSwfUrl:'swf/mfroomplayer/mfroomplayer.swf',
  bubbleUrl:'http://pics.beeshow.tv/icons/of/game/',
  pluginLowVersion:'408',
  pluginVersion:[''],
  PROJECT_TYPE : projectType.PROJECT_MI_FENG,
  anchorVideoH5 : true,
  flashLog: false,
  limitRoomNum:5,
  //要屏蔽的插件数组
  forbitPluginArr:["6RoomsCamV10","YY伴侣","酷狗直播伴侣","91KBOX","秀色直播助手","蜜疯直播助手","红人直播助手","乐嗨直播助手","嗨秀直播助手"],
  foraudioPluginArr:["默认","通讯"],
  mobileBoundText:'绑定手机号，账号有保障！',
  pcdnswfUrl:location.protocol=='https:' ? "https://www.beeshow.tv/swf/pcdn_acc_live.swf" : "http://www.beeshow.tv/swf/pcdn_acc_live.swf",
  websocketProtocol: 'wss://',
  opDomain:'rdtest',
  opVersion:'8.1.3',
  opSpace:'showspace',
  opTerminal:'W',
  opProDomain:'openfire.cn',
  //以下属性已提取配置文件
  getPCInfoTime:30,  //每隔30秒获取一次CPU占用率   单位：秒
  getPCInfoCount:10,  //获取CPU占用率累计次数，满10次后计算平均值
  cpuUtilizationMaxAvg:95.00  //CPU占有率最大值(代表95%)
};
export {
  baseUrls,
  routerMode,
  imgBaseUrl,
  isLocal,
  opSpace,
  opTerminal,
  opVersion,
  opDomain,
  websocketProtocol,
  systemVar,
  isShowLoginMobile,
  testEnvironment,
  vid,
  weixinAppKey,
  payChannelId,
  isCounting,
  logUrl,
  projectVar,
  websocketServiceURL
}



// WEBPACK FOOTER //
// ./src/config/env.js